import React, { useRef } from 'react';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useStore } from '../../../context/StoreProvider';

export default function TransLang() {
    const { changeLanguage } = useStore();
    const { i18n } = useTranslation();
    const switchingRef = useRef(false);

    // ✅ مصدر الحقيقة: i18n (وليس currentLang)
    const lng = i18n.resolvedLanguage || i18n.language || 'ar';

    const toggleLanguage = async () => {
        if (switchingRef.current) return;

        const otherLng = lng === 'en' ? 'ar' : 'en';

        try {
            switchingRef.current = true;
            await Promise.resolve(changeLanguage(otherLng));
        } finally {
            switchingRef.current = false;
        }
    };

    return (
        <Typography
            onClick={toggleLanguage}
            color={'primary.text'}
            fontWeight={'bold'}
            variant="h6"
            sx={{ fontSize: '1.2rem', cursor: 'pointer' }}
        >
            {lng === 'en' ? 'AR' : 'EN'}
        </Typography>
    );
}
